import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './MenuItemWithCheckbox.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseMenuItemWithCheckbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsxs(views.MenuItem, _objectSpread(_objectSpread(_objectSpread({
    checked: Boolean(rest.selected),
    selectedIcon: false,
    ref: ref
  }, rest), tokens), {}, {
    children: [_jsx(views.MenuItemCheckbox, {
      name: String(children),
      checked: rest.selected,
      tag: "span"
    }), children]
  }));
});
var MenuItemWithCheckbox = withDesignTokens(BaseMenuItemWithCheckbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      hoverBorderColor: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      hoverBorderColor: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverBorderColor: theme.palette.twilio.gray[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      hoverBorderColor: theme.palette.twilio.gray[100]
    };
  }
});
export default MenuItemWithCheckbox;